import { h } from 'preact'
import Header from '../header'
import MethodBoxSAML from './MethodBoxSAML'

interface Props {
  onSAMLInstall: () => void
}

const SSOOverviewPresenter = ({ onSAMLInstall }: Props) =>
  <div>
    <Header
      title='SSO'
      disableCancelButton
      disableSaveButton
    />
    <div class='sso-overview sso-settings'>
      <div className='sso-method-title'>SSO method</div>
      <MethodBoxSAML
        onSAMLInstall={onSAMLInstall}
      />
    </div>
  </div>

export default SSOOverviewPresenter
